module.exports = __webpack_public_path__ + "img/fixed-image-login.5ede0ccf.png";